import React from "react";

export const PRICE_MIN = 0;
export const PRICE_MAX = 5000;

export const fmtPrice = (val: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(val);

// pointer-events-none en el input, pointer-events-auto solo en el thumb →
// cada thumb responde únicamente a sus propios eventos aunque estén superpuestos
const INPUT_CLS = [
  "absolute inset-x-0 w-full h-4",
  "appearance-none bg-transparent pointer-events-none",
  "[&::-webkit-slider-runnable-track]:bg-transparent",
  "[&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:pointer-events-auto",
  "[&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4",
  "[&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:shadow [&::-webkit-slider-thumb]:cursor-pointer",
  "[&::-moz-range-track]:bg-transparent",
  "[&::-moz-range-thumb]:pointer-events-auto",
  "[&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4",
  "[&::-moz-range-thumb]:bg-white [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:shadow [&::-moz-range-thumb]:cursor-pointer",
].join(" ");

interface Props {
  rangeMin: number;
  rangeMax: number;
  min: number;
  max: number;
  onMinChange: (v: number) => void;
  onMaxChange: (v: number) => void;
}

const PriceRange: React.FC<Props> = ({ rangeMin, rangeMax, min, max, onMinChange, onMaxChange }) => {
  const range = rangeMax - rangeMin || 1;
  const step = Math.max(1, Math.round(range / 100));
  const minPct = ((min - rangeMin) / range) * 100;
  const maxPct = ((max - rangeMin) / range) * 100;

  return (
    <div className="border border-white/30 rounded-xl p-4 [box-shadow:0_4px_12px_-4px_rgba(0,0,0,0.1),inset_4px_4px_14px_rgba(0,0,0,0.15),1px_1px_1px_rgba(255,255,255,0.14)]">
      {/* Track visual + inputs superpuestos */}
      <div className="relative flex items-center h-4 mb-4">
        {/* Track base */}
        <div className="absolute inset-x-0 h-3 border border-white/40 rounded-full" />
        {/* Fill verde entre thumbs */}
        <div
          className="absolute h-3 bg-[#05EE84] rounded-full"
          style={{ left: `${minPct}%`, right: `${100 - maxPct}%` }}
        />
        <input
          type="range" min={rangeMin} max={rangeMax} step={step} value={min}
          onChange={e => onMinChange(Math.min(Number(e.target.value), max - step))}
          className={INPUT_CLS}
        />
        <input
          type="range" min={rangeMin} max={rangeMax} step={step} value={max}
          onChange={e => onMaxChange(Math.max(Number(e.target.value), min + step))}
          className={INPUT_CLS}
        />
      </div>
      <div className="flex justify-between text-sm">
        <span>{fmtPrice(min)}</span>
        <span>{fmtPrice(max)}</span>
      </div>
    </div>
  );
};

export default PriceRange;
